import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'

export const STORAGE_YEAR_KEY = 'year'
export const STORAGE_MONTH_KEY = 'month'
export const STORAGE_IMGNAME_KEY = 'imgName'
export const STORAGE_BACKUPINFO_KEY = 'imgName'
export const STORAGE_INCOMECOST_KEY = 'incomeCostData'
export const STORAGE_INCOMEDETAIL_KEY = 'incomeDetailData'
export const STORAGE_COSTDETAIL_KEY = 'costDetailData'

Vue.use(Vuex)

const state = {
  year: (window.localStorage.getItem(STORAGE_YEAR_KEY) || ''),
  month: (window.localStorage.getItem(STORAGE_MONTH_KEY) || ''),
  yearToShared: '0000',
  monthToShared: '00',
  imgName: (window.localStorage.getItem(STORAGE_IMGNAME_KEY) || ''),
  backupInfo: (window.localStorage.getItem(STORAGE_BACKUPINFO_KEY) || '[]'),
  incomeCostData: JSON.parse(window.localStorage.getItem(STORAGE_INCOMECOST_KEY) || '{}'),
  incomeDetailData: JSON.parse(window.localStorage.getItem(STORAGE_INCOMEDETAIL_KEY) || '{}'),
  costDetailData: JSON.parse(window.localStorage.getItem(STORAGE_COSTDETAIL_KEY) || '{}')
}

const mutations = {
  ['SET_YEAR_AND_MONTH'] (state, yearMonth) {
    state.year = yearMonth.year
    state.month = yearMonth.month
    window.localStorage.setItem(STORAGE_YEAR_KEY, yearMonth.year)
    window.localStorage.setItem(STORAGE_MONTH_KEY, yearMonth.month)
  },
  ['SET_YEAR_AND_MONTH_TS'] (state, yearMonth) {
    state.yearToShared = yearMonth.year;
    state.monthToShared = yearMonth.month;
  },
  ['SET_IMG_NAME'] (state, imgName) {
    state.imgName = imgName
    window.localStorage.setItem(STORAGE_IMGNAME_KEY, imgName)
  },
  ['SET_BACKUP_INFO'] (state, backupInfo) {
    state.backupInfo = backupInfo
    window.localStorage.setItem(STORAGE_BACKUPINFO_KEY, backupInfo)
  },
  ['SET_INCOME_COST_DATA'] (state, incomeCostData) {
    state.incomeCostData = incomeCostData
    window.localStorage.setItem(STORAGE_INCOMECOST_KEY, JSON.stringify(incomeCostData))
  },
  ['SET_INCOME_DETAIL_DATA'] (state, incomeDetailData) {
    state.incomeDetailData = incomeDetailData
    window.localStorage.setItem(STORAGE_INCOMEDETAIL_KEY, JSON.stringify(incomeDetailData))
  },
  ['SET_COST_DETAIL_DATA'] (state, costDetailData) {
    state.costDetailData = costDetailData
    window.localStorage.setItem(STORAGE_COSTDETAIL_KEY, JSON.stringify(costDetailData))
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/vuex/store.js